<!--
 * @Author: cgh
 * @Date: 2022-07-21
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:04:29
 * @Description: 维保检测项查看
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-90 o-dialog--lg-90 o-dialog--xl-90 o-dialog-h--85"
    title="维保检测项查看"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <div class="l-page--inner l-page--search">
      <el-form
        ref="filterParams"
        class="c-form c-condition__form u-mg-b-10"
        :model="filterParams"
        :inline="true"
        label-position="right"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="8"
          >
            <el-form-item
              class="c-form__item"
              label="检测内容"
              prop="jcnrDm"
            >
              <select-sb
                v-model="filterParams.jcnrDm"
                clearable
                type="wb"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="5"
          >
            <el-form-item
              class="c-form__item"
              label="维保类型"
              prop="wblx"
            >
              <el-select
                v-model="filterParams.wblx"
                clearable
                class="c-form__select"
                style="width: 100%;"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in wbType"
                  :key="item.id"
                  :value="item.id"
                  :label="item.text"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="5"
          >
            <el-form-item
              style="margin-left: 10px;"
              class="c-form__item"
            >
              <k-button
                btn-text="查询"
                :auth-type="false"
                type="primary"
                icon="kestrel-icon ki-search"
                @click="refreshSearch()"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        class="l-page__body l-page--search__body"
        style="margin: 0;"
      >
        <!-- 查询条件 End -->
        <k-table
          ref="kTable"
          height="100%"
          :table-column="tableColumn"
          :data="page.rows"
          :pagination-show="false"
        >
          <!-- <template
        #sbzt="scope"
      >
        {{ scope.row.sbzt === 'GZ'?'故障':scope.row.sbzt === 'ZC'? '正常': '' }}
      </template> -->
          <!-- <template
            #clyyMc="scope"
          >
            {{ scope.row.clyyMc }}{{ scope.row.clyy === null?'':(scope.row.clyy) }}
          </template> -->
          <!-- <template
        #zy
      >
        <i
          class="kestrel-icon ki-question-circle u-text-primary u-text-16 u-pointer"
          @click="handleDialog('czzy')"
        />
      </template> -->
        </k-table>
      </div>
    </div>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
    <!-- -->
    <wbxmx-dialog
      v-if="showDialogName==='wbxmx'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
    />
    <czzy-dialog
      v-if="showDialogName==='czzy'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
    />
  </el-dialog>
</template>

<script>
import { wbjhService } from '../wbjh.service.js';
export default {
  name: 'ViewDialog',
  components: {
    wbxmxDialog: () => import('./wbxmxDialog'),
    czzyDialog: () => import('./czzyDialog')
  },
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载
      // jhid: null,
      // xtid: null, // 系统ID
      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 end */
      /* 表单参数 Start */

      /** 查询条件 */
      filterParams: {
        xfxtId: null,
        xfsbId: null,
        jhId: null,
        wblx: null, // 维保类型
        jcnrDm: null // 检测内容
      },
      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xfsbBh', label: '设备编号', align: 'left', minWidth: '120', type: 'text' },
        { key: 'zylzMc', label: '维保类型', align: 'left', minWidth: '120', type: 'text' },
        { key: 'xfsbMc', label: '设备名称', align: 'left', minWidth: '180', type: 'text' },
        { key: 'jcx', label: '检测项', align: 'left', minWidth: '220', type: 'text' },
        { key: 'sbztMc', label: '设备情况', align: 'center', width: '130', type: 'text' },
        { key: 'clyy', label: '故障及处理', align: 'center', width: '130', type: 'dateTime' }
        // { key: 'zy', slotName: 'zy', label: '指引', align: 'center', width: '130', type: 'dateTime' }
      ],
      /* 表格列配置End */

      /**
       * 实际查询条件
       */
      trueFilterParams: {}
      /* 表单校验规则 End */
    };
  },
  computed: {
    // 维保类型
    wbType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_ZYLX) {
        return enums.IFF_ZYLX;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
       * @description: 跳转到查看
       * @author: cgh
       */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
      this.dialogParams = _params;
    },
    /**
     * 初始化数据
     */
    // init () {
    //   this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
    //   this.search();
    // },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      const jcnr = this.filterParams.jcnrDm.split('/');
      this.filterParams.xfxtId = jcnr[0];
      this.filterParams.xfsbId = jcnr[1];
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      this.loading = true;
      wbjhService.getWbjcxtb(this.trueFilterParams)
        .then(rsp => {
          this.page.rows = rsp.data;
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    // 获取该计划id
    this.filterParams.jhId = this.dlParams.jhid;
    // 获取该系统id
    this.filterParams.xfxtId = this.dlParams.xtid;
    this.filterParams.jcnrDm = this.dlParams.xtid + '/';
    // 初始化数据
    this.refreshSearch();
  }
};

</script>
